import axios from "axios";
import Config from "../../utils/Config";
class AuthService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  getAuthHeaders() {
    return {
      headers: {
        ContentType: "application/json",
        Authorization: `Bearer ${localStorage.getItem("dbx_aff_tkn")}`,
      },
    };
  }

  async register(payload) {
    try {
      const response = await axios.post(
        `${Config.devBackendDomain}affiliate/register`,
        payload,
        this.getHeaders()
      );
      return {
        status: response?.data?.data?.in_error === false,
        data: response?.data?.data?.data,
        message: response?.data?.data?.reason || "Registration successful",
        statusCode: response?.data?.data?.status_code,
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error?.response?.data?.data?.reason || "Something went wrong",
        statusCode: error?.response?.data?.data?.status_code,
      };
    }
  }

  async Login(payload) {
    try {
      const response = await axios.post(
        `${Config.devBackendDomain}affiliate/login`,
        payload,
        this.getHeaders()
      );

      return {
        status: true,
        message: response?.data?.data?.reason || "Login successful",
        data: response?.data?.data,
      };
    } catch (error) {
      return {
        status: false,
        message: error?.response?.data?.data?.reason || "Something went wrong",
        data: null,
      };
    }
  }

  async forgotPassword(payload) {
    try {
      const response = await axios.post(
        `${Config.devBackendDomain}affiliate/email/resetpassword`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        data: response?.data?.data,
        message: response?.data?.data?.reason || "OTP sent successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error?.response?.data?.reason || "Something went wrong",
      };
    }
  }

  async resendOtp(payload) {
    try {
      const response = await axios.post(
        `${Config.devBackendDomain}affiliate/resend/verificationCode`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        data: response?.data?.data,
        message: response?.data?.data?.reason || "OTP sent successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error?.response?.data?.reason || "Something went wrong",
      };
    }
  }

  async resetPassword(payload) {
    try {
      const response = await axios.post(
        `${Config.devBackendDomain}affiliate/resetpassword`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        data: response?.data?.data,
        message: response?.data?.data?.reason || "Password reset successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error?.response?.data?.reason || "Something went wrong",
      };
    }
  }

  async updateProfile(payload) {
    try {
      const response = await axios.post(
        `${Config.devBackendDomain}affiliate/update/profile`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        data: response?.data?.data,
        message: response?.data?.data?.reason || "Profile Updated Successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error?.response?.data?.reason || "Sorry, Something went wrong",
      };
    }
  }

  async verifyEmail(payload) {
    try {
      const response = await axios.post(
        `${Config.devBackendDomain}affiliate/verify/account`,
        payload,
        this.getHeaders()
      );
      return {
        status: response?.data?.data?.in_error === false,
        data: response?.data?.data?.data,
        message: response?.data?.data?.reason || "Email verified successfully",
        statusCode: response?.data?.data?.status_code,
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error?.response?.data?.data?.reason || "Verification failed",
        statusCode: error?.response?.data?.data?.status_code,
      };
    }
  }

  async resendVerificationCode(payload) {
    try {
      const response = await axios.post(
        `${Config.devBackendDomain}affiliate/resend/verificationCode`,
        payload,
        this.getHeaders()
      );
      return {
        status: response?.data?.data?.in_error === false,
        data: response?.data?.data?.data,
        message: response?.data?.data?.reason || "Verification code sent successfully",
        statusCode: response?.data?.data?.status_code,
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error?.response?.data?.data?.reason || "Failed to resend verification code",
        statusCode: error?.response?.data?.data?.status_code,
      };
    }
  }
}

const authService = new AuthService();
export default authService;
